export default __webpack_public_path__ + "static/media/animated_logo.fb5dc6c9.svg";